import React, { useCallback, useEffect } from 'react';
import { Grid } from '@mui/material';

import DetailsCard from '../../../common/details-card/DetailsCard';
import BankDetailsCard from '../../../common/bank-details-card/BankDetailsCard';
import { useAppDispatch } from '../../../common/hooks/useAppDispatch';
import {
  fetchBusinessProfileBankDetails,
  fetchBusinessProfileById,
  selectBusinessProfileBankDetails,
} from '../../../slices/business-profile/businessProfileSlice';
import { useAppSelector } from '../../../common/hooks/useAppSelector';
import { Company } from '../../../models/company.model';
import BizCoverBanner from '../../../common/bizcover-banner';

interface DetailsTabsProps {
  company: Company;
  key: string;
}

const DetailsTabs: React.FC<DetailsTabsProps> = ({ company }) => {
  const dispatch = useAppDispatch();
  const BusinessProfileBankDetails = useAppSelector(selectBusinessProfileBankDetails);

  const fetchDetails = useCallback(() => {
    if (company?.id) {
      dispatch(fetchBusinessProfileById({ id: company?.id }));
      dispatch(fetchBusinessProfileBankDetails({ companyId: company?.id }));
    }
  }, [dispatch, company?.id]);

  useEffect(() => {
    fetchDetails();
  }, [fetchDetails]);

  return (
    <>
      <Grid component='div' container wrap='wrap' style={{ rowGap: '16px', paddingBottom: '16px' }}>
        <Grid component='div' size={{ xs: 12 }}>
          <BizCoverBanner variant='wide' />
        </Grid>

        <Grid component='div' size={{ xs: 12 }}>
          <DetailsCard company={company} />
        </Grid>

        <Grid component='div' size={{ xs: 12 }}>
          {BusinessProfileBankDetails &&
            BusinessProfileBankDetails.length > 0 &&
            BusinessProfileBankDetails.map((bank) => (
              <Grid component='div' key={bank.id}>
                <BankDetailsCard bank={bank} />
              </Grid>
            ))}
        </Grid>
      </Grid>
    </>
  );
};

export default DetailsTabs;
